// extracted by mini-css-extract-plugin
module.exports = {"container-title-dashboard":"dashboard_container-title-dashboard__Zws-E","img-wrapper":"dashboard_img-wrapper__1bo1D"};